/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreInAppEGSEgsInAppBillingData } from './FxIdApplicationStoreInAppEGSEgsInAppBillingData';
import {
    instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData,
    FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSON,
} from './FxIdApplicationStoreInAppEGSEgsInAppBillingData';

/**
 * @type FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData
 * 
 * @export
 */
export type FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData = FxIdApplicationStoreInAppEGSEgsInAppBillingData;

export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData {
    return FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData(json)) {
        return FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSON(json: any): any {
    return FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData(value)) {
        return FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSON(value as FxIdApplicationStoreInAppEGSEgsInAppBillingData);
    }

    return {};
}

